import { FilterType } from './types';

export const LIBRARY_NOT_ARCHIVED_FILTERS: FilterType[] = [
  { field: 'libraryStatus', operator: 'is not', value: '-archived' },
];

export const LIBRARY_INCLUDE_ARCHIVED: FilterType[] = [{ field: 'archived', operator: 'is', value: 'include' }];
